import React, { ReactElement } from 'react'
import Image from 'next/image'
import src from '../../../../../public/studyMaterialsGuide/owlHasIdeaWithBackground.webp'

export const OwlHasIdeaWithBackground: React.FC<unknown> = (): ReactElement => (
    <Image src={src} alt={'eupheus has a good idea!'} />
)
